module.exports = __webpack_public_path__ + "img/three-iphones-mobile.b0079721.png";